import axios from "axios";
import { EnvironmentRegistry } from "./registry/environmentRegistry";
import { User } from "../types/types";
import {
  outletMetaData,
  updateType,
} from "../features/editAndView/ViewAndEditType";
import {
  ChannelkartNetworkGet,
  ChannelkartNetworkPost,
  ChannelkartNetworkPut,
} from "./networkService";
import {
  divisonType,
  modelDataType,
  Role,
  userModalFormType,
} from "../components/userModal/userModalType";
import { outletForModelType } from "../components/ouletModal/OutletModalTypes";
import { productMetaData } from "../components/productModal/ProductModalTypes";
import { downloadReport, getReport, getReportFilterAttribute, task } from "./reportService";
import { openPopup } from "../stateManagement/actions/popupActions";
import { genericFilterType } from "../stateManagement/reducers/genericFilterReducer";
import { getFilterString } from "./mdmService/mdmService";
import { getAccessToken } from "./authenticationService";
import { DataConfig } from "./mdmService/types";

export async function getUserFromToken(
  token: string,
  env: string
): Promise<User> {
  const url = EnvironmentRegistry.getUrl(env);
  const headers = EnvironmentRegistry.makeAuthHeaders(token);
  const response = await ChannelkartNetworkGet("/login/user",undefined,headers);
  // const response = await axios.get(`${url}/login/user`, { headers });
  
  return response.data as User;
}

export async function getAllEntityMetaData(
  entity: string,
  page: number,
  searchedValue?: string,
  searchEnabledColumns?: string[],
  designation?: string,
  globalFilters?: genericFilterType,
  getDataConfig?:DataConfig
) {
  console.log("getDataConfig",getDataConfig)
  let url = `/${entity}?page=${page}&size=30`;
  if(entity==="outletDetails"){
    url = `/${entity}?minimalResponse=true&page=${page}&size=30`;
  }
  if (searchedValue && searchEnabledColumns) {
    if(getDataConfig && getDataConfig.searchKey){
      url = url.concat(`&${getDataConfig.searchKey}=`, searchedValue);
    }else{
      url = url.concat("&filter=");
      let endFilters = searchEnabledColumns.reduce(
        (accumulator, currentValue) => {
          return accumulator + `${currentValue}[regex]:${searchedValue}%20OR%20`;
        },  
        ""
      );
      endFilters = endFilters.substring(0, endFilters.length - 8);
      url = url.concat(endFilters);
      if(designation && designation.length>0){
        url = url.concat(`%20and%20designation:${designation}`);
      }
    }
  }else if(designation && designation.length>0){
    url = url.concat(`&filter=designation:${designation}`);
  }
  if(globalFilters && Object.keys(globalFilters).length){
    if(getDataConfig && getDataConfig.searchKey){
      const keyMapping: { [key: string]: string } = {
        "smart_buy": "sbu" 
      };
      const queryString = Object.entries(globalFilters)
      .filter(([_, value]) => value !== "" && value !== null)
      .map(([key, value]) => {
        const newKey = keyMapping[key] || key; 
        return `${encodeURIComponent(newKey)}=${encodeURIComponent(value.toString())}`;
      })
      .join('&');
      url = url.concat("&", queryString);
    }else{
      const globalFiltersString = getFilterString(globalFilters,entity==="users");
      url += (url.includes("filter=")? ` AND ${globalFiltersString}` : `&filter=${globalFiltersString}`);
    }
  }
  const response = await ChannelkartNetworkGet(url);
  return response;
}
export async function getAllEntityMetaDataNew(
  entity: string,
  page: number,
  searchedValue?: string,
  searchEnabledColumns?: string[],
  designation?: string,
  globalFilters?: genericFilterType,
  getDataConfig?:DataConfig
) {
  console.log("getDataConfig",getDataConfig)
  let url = `/${entity}?page=${page}&size=30&source=portal&sort=creationTime:desc`;
  if (searchedValue && searchEnabledColumns) {
    if(getDataConfig && getDataConfig.searchKey){
      url = url.concat(`&${getDataConfig.searchKey}=`, searchedValue);
    }else{
      url = url.concat("&filter=");
      let endFilters = searchEnabledColumns.reduce(
        (accumulator, currentValue) => {
          return accumulator + `${currentValue}[regex]:${searchedValue}%20OR%20`;
        },  
        ""
      );
      endFilters = endFilters.substring(0, endFilters.length - 8);
      url = url.concat(endFilters);
      if(designation && designation.length>0){
        url = url.concat(`%20and%20designation:${designation}`);
      }
    }
  }else if(designation && designation.length>0){
    url = url.concat(`&filter=designation:${designation}`);
  }
  if(globalFilters && Object.keys(globalFilters).length){
    if(getDataConfig && getDataConfig.searchKey){
      const keyMapping: { [key: string]: string } = {
        "smart_buy": "sbu" 
      };
      const queryString = Object.entries(globalFilters)
      .filter(([_, value]) => value !== "" && value !== null)
      .map(([key, value]) => {
        const newKey = keyMapping[key] || key; 
        return `${encodeURIComponent(newKey)}=${encodeURIComponent(value.toString())}`;
      })
      .join('&');
      url = url.concat("&", queryString);
    }else{
      const globalFiltersString = getFilterString(globalFilters,entity==="users");
      url += (url.includes("filter=")? ` AND ${globalFiltersString}` : `&filter=${globalFiltersString}`);
    }
  }
  const response = await ChannelkartNetworkGet(url);
  return response;
}

export const donwloadReportWithStatus = async (id: string,setOpenReportModal:React.Dispatch<React.SetStateAction<boolean>>) => {
  const res = await task(id);
  let data = res.data.features[0];
  if (data.status === "SUCCESS") {
    setOpenReportModal(false);
    await download(id);
  } else if (data.status === "INPROGRESS") {
    setTimeout(() => donwloadReportWithStatus(id,setOpenReportModal), 2000);
  } else {
    setOpenReportModal(false);
    openPopup("Error", "Error");
  }
};

const download = async (id: string) => {
  await getReport(id);
};

export async function downloadMasterDataReport(entity: string,exportConfig?: any,globalFilterValues?: genericFilterType) {
  try {
    if(exportConfig){
        const reqBody: any={
          "attributes":{
            "format":exportConfig.format,
            "name":exportConfig.name
          },
          "lob":localStorage.lob
      }
      if(globalFilterValues && Object.keys(globalFilterValues).length !==0){
        const filter = getReportFilterAttribute(globalFilterValues);
        reqBody.attributes.filter = filter;
      }
      const response = await downloadReport(reqBody);
      // await donwloadReportWithStatus(response.data.id,setOpenReportModal);
      return response;
    }
    else{
      const response = await ChannelkartNetworkGet(
        `/v1/masterdatareports/${entity}`
      );
      return response;
    }
  } catch (error) {
    return error;
  }
}

export async function getDivision() {
  try {
    const response = await ChannelkartNetworkGet(`/v1/divisions?size=1000`);
    const alldivisons = response.data.features.map((item: divisonType) => {
      return {
        divisionName: item.divisionName,
        divisionLevel: item.level,
      };
    });
    return alldivisons;
  } catch (error) {
    return [];
  }
}

export async function getManagerId(designation: string) {
  try {
    const response = await ChannelkartNetworkGet(
      `/users?filter=designation:${designation}`
    );
    const allManagers = response.data.features.map((item: modelDataType) => {
      return item.immediateParent;
    });
    return allManagers;
  } catch (error) {
    return error;
  }
}

export async function getReportingManagerDesignation(managerId: string) {
  try {
    const response = await ChannelkartNetworkGet(
      `/users?filter=loginId:${managerId}`
    );
    return response;
  } catch (error) {
    return error;
  }
}

export async function resetPassword(loginId: string) {
  try {
    const response = await ChannelkartNetworkPost(
      `/changePassword/reset/${loginId}`
    );
    return response;
  } catch (err) {
    return err;
  }
}

export async function resetStatus(
  endPoint: string,
  dataObj: productMetaData | outletMetaData | updateType | undefined
) {
  try {
    const response = await ChannelkartNetworkPut(endPoint, dataObj);
    return response;
  } catch (err) {
    return err;
  }
}

export async function updateUser(dataObj: userModalFormType) {
  try {
    const response = await ChannelkartNetworkPut("/users?source=portal&callType=scheduled", dataObj);
    return response;
  } catch (error) {
    return error;
  }
}



export async function getAdditionalData(endPoint: string | undefined) {
  if (endPoint) {
    const response = await ChannelkartNetworkGet(endPoint);
    return response;
  }
}

export async function getBlob(formData: FormData) {
  try {
    const response = await ChannelkartNetworkPost(
      "/v1/uploadFile/images",
      formData,
      { "Content-Type": "multipart/form-data" }
    );
    return response;
  } catch (error) {
    return error;
  }
}

export async function updateProduct(dataObj: productMetaData) {
  try {
    const response = await ChannelkartNetworkPut("/products", dataObj);
    return response;
  } catch (error) {
    return error;
  }
}

export async function updateOutlet(dataObj: outletForModelType) {
  try {
    const response = await ChannelkartNetworkPut(
      "/outletDetails/update",
      dataObj
    );
    return response;
  } catch (error) {
    return error;
  }
}

export async function getEntityWithAndFilter(
  entity: string,
  page: number,
  searchedValue?: string[],
  searchEnabledColumns?: string[],
  loginId?: string
) {
  let url = `/${entity}?page=${page}&size=30`;

  if (searchedValue && searchEnabledColumns) {
    url = url.concat("&filter=");
    let curIndex=0;
    let endFilters = searchEnabledColumns.reduce(
      (accumulator, currentValue) => {
        return accumulator + `${currentValue}:${searchedValue[curIndex++]}%20AND%20`;
      },
      ""
    );
    if(loginId){
      endFilters=endFilters+`loginId[regex]:${loginId}`;
    }else{
      endFilters = endFilters.substring(0, endFilters.length - 9);
    }
    url = url.concat(endFilters);
  }
  const response = await ChannelkartNetworkGet(url);
  return response;
}



export async function activateInactiveUser(loginId:String) {
  try {
    const response = await ChannelkartNetworkPost(`/users/activateInactivatedUser/${loginId}`);
    return response;
  } catch (error) {
    return error;
  }
}

export async function fetchAllRoles(){
  try{
    const url = "/v1/roles";
    const response = await ChannelkartNetworkGet(url);
    return response.data.features;
  }catch(error){
    return [];
  }
}
